import { Button } from '@eb/eds-button';
import { gettext } from '@eb/i18n';
import { trackAnalyticsEvent } from '@eb/site-analytics';
import React, { useContext } from 'react';
import { GA_PROFILE_CATEGORY, GA_PROFILE_SHOW_ACTION } from '../../constants';
import { ReadMoreContext } from './context';
import './ReadMore.scss';
import { ReadMoreToggleProps } from './types';

const readMoreToggleDefaults: ReadMoreToggleProps = {
    labels: {
        show: gettext('Show more'),
        hide: gettext('Show less'),
    },
};

const handleOnClick = (state: boolean, callback?: Function) => {
    trackAnalyticsEvent({
        category: GA_PROFILE_CATEGORY,
        label: state ? 'show more' : 'show less',
        action: GA_PROFILE_SHOW_ACTION,
    });
    callback?.(state);
};

export const ReadMoreToggle: React.FunctionComponent<ReadMoreToggleProps> = (
    props,
) => {
    const { isExpanded, setExpanded, isClamped } = useContext(ReadMoreContext);

    if (!isClamped) {
        return null;
    }

    return (
        <div className="read-more__toggle">
            <Button
                data-testid="read-more-toggle"
                style="none"
                onClick={() => {
                    handleOnClick(!isExpanded, setExpanded);
                }}
            >
                <span className="eds-link">
                    {isExpanded ? props.labels?.hide : props.labels?.show}
                </span>
            </Button>
        </div>
    );
};

ReadMoreToggle.defaultProps = readMoreToggleDefaults;
